// extracted by mini-css-extract-plugin
module.exports = {"form":"_2M0DD","sellcarContainer":"_34l3r","closeIcon":"VEUYn","progressBar":"_3ljmm"};